import React from 'react';
import Lottie from 'lottie-react';
import { Box } from '@mui/material';
import useLottieAnimation from 'src/hooks/useLottieAnimation';

// ----------------------------------------------------------------------

export default function LoadingScreen({
  size = 120,
  noScale = false,
  ...other
}) {
  const { animationData } = useLottieAnimation();

  return (
    <Box
      sx={{
        height: noScale ? 'auto' : '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
      }}
      {...other}
    >
      {animationData ? (
        <Lottie
          animationData={animationData}
          style={{ height: size, width: size }}
          loop={true}
          autoplay={true}
        />
      ) : (
        <Box
          sx={{
            width: size,
            height: size,
            bgcolor: 'grey.200',
            borderRadius: '50%',
          }}
        />
      )}
    </Box>
  );
}
